import { Field } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import DefaultActionButtonGenerator from "../../components/action-buttons/ActionButtonGenerator";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import MultiSelect from "../../components/form-fields/MultiSelect";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";

function CreateUser(props) {
  const [initialValues, setInitialValues] = useState({});
  const [selectedRows, setSelectedRow] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [filters, setFilters] = useState([]);
  const [refreshList, setRefreshList] = useState(false);
  const [t] = useTranslation();

  const validationSchema = yup.object({});

  const arrangeBeforePersist = (values) => {
    let payload = {
      grupIds: values.kurumRowGrpIds,
      roleId: values.roleId,
      userIds: selectedRows.map((sr) => sr.userId),
    };
    return payload;
  };
  const onAddButtonClicked = () => {
    setShowModal(true);
    setInitialValues({});
  };

  const mapDataBeforeList = (row) => {
    row.fullName = (row.firstName || "") + " " + (row.lastName || "");
    return row;
  };

  const closeModal = () => {
    setShowModal(false);    
    setFilters([]);
  };

  return (
    <CrudMain
      onAddButtonClicked={onAddButtonClicked}
      showModal={showModal}
      setShowModal={setShowModal}
      closeModal={closeModal}
      title="Kullanıcı Ekle"
      size={"lg"}
      unscrollable
    >
      <FormikForm
        endPointUrl="user/addNewUser"
        arrangeBeforePersist={arrangeBeforePersist}
        configPointUrl="user/config"
        initialValues={initialValues}
        validationSchema={validationSchema}
        closeModal={() => setShowModal(false)}
        refreshList={() => props.setRefreshList(!props.refreshList)}
        setConfigData={(data) => setConfigData(data)}
      >
        <Field
          name="username"
          label={t("demandList.kullaniciAdi")}
          colNumber="12"
          component={TextInput}
          onChangeFunc={(val) => {
            setFilters({
              fieldName: "name",
              value: val,
              oper: "CONTAINS",
            });
          }}
        />

        <div className="col-md-12">
          <button
            className="submit btn btn-primary float-right btn-sm"
            onClick={() => {
              setRefreshList(!refreshList);
            }}
          >
            Kullanıcı Ara
          </button>
        </div>

        <div className={"form-group col-md-12 mt-3"}>
          <ListComponent
            entityName="create-user"
            endpoint="user/search-list"
            keyField="id"
            mapDataBeforeList={mapDataBeforeList}
            isMultiSelect
            hideBorder
            setSelectedRow={setSelectedRow}
            customBody={{
              filters: filters,
            }}
            refreshList={refreshList}
            columns={[
              // {
              //   dataField: "userId",
              //   text: "ID",
              //   sort: true,
              //   headerClasses: "id-header",
              // },

              {
                dataField: "username",
                text: `${t("demandList.kullaniciAdi")}`,
                sort: true,
              },
              {
                dataField: "fullName",
                text: `${t("demandList.adiSoyadi")}`,
                sort: true,
              },
              {
                dataField: "email",
                text: `${t("demandList.ePosta")}`,
                sort: true,
              },
            ]}
            actionButtonsObject={{
              actions: [],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
        <Field
          name="kurumRowGrpIds"
          label="Şirket Grubu"
          colNumber="12"
          component={MultiSelect}
          options={configData && configData.groups}
          onChangeFunc={() => {}}
        />
        <Field
          name="roleId"
          label="Rol"
          colNumber="12"
          component={Select}
          options={configData && configData.roles}
        />
      </FormikForm>
    </CrudMain>
  );
}

export default CreateUser;
